import { useParams } from "react-router-dom"
import { AdjustmentInventoryType, AdjustmentInventoryValidation, finalData, useDataAdjustmentDetail, validateAdjusmentDetail } from "./utils"
import { FooterMenu, Loading } from "components"
import { DataCountType } from "../types"
import moment from "moment"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { LocationProvider } from "contexts"
import { AttachmentModal, FormDirectAdjusment, JournalAdjusment, PrintAdjustmentInventory } from "./components"
import toast from "react-hot-toast"
import { useApi, useToggle } from "utils"
import { LinkAccountProvider } from "./contexts"


export function EditAdjustmentInventory() {
    const { adjustment_id } = useParams()
    const { data, isLoading, refetch } = useDataAdjustmentDetail(adjustment_id!, true)


    if (isLoading || !data) {
        return <Loading errorText="No data available" loading={isLoading} />
    }

    return (
        <ViewSection data={data} adjusmentId={adjustment_id!} refetch={refetch} />
    )
}

function ViewSection(props: {
    data: DataCountType,
    adjusmentId: string
    refetch?: () => void
}) {
    const { isActive, toggle } = useToggle(false)
    const api = useApi()

    const defaultValues: AdjustmentInventoryType = {
        trx_code: props.data.invcount.trx_code,
        employee_id: props.data.invcount.employee_id.toString() ?? "",
        location_id: props.data.invcount.location_id.toString() ?? "",
        memo: props.data.invcount.memo,
        transaction_date: moment(props.data.invcount.transaction_date).format("YYYY-MM-DD"),
        adjusmentDetail: props.data.countdetail.map((item) => {
            return {
                product_id: Number(item.product_id),
                mr_unit_id: Number(item.mr_unit_id),
                coa_coex_id: Number(item.coa_coex_id),
                coa_inventory_id: Number(item.coa_inventory_id),
                different_adjustment: Number(item.different_adjustment),
                different_unit: Number(Math.abs(item.different_unit)),
                amount_adjustment: Number(item.amount_adjustment),
                position: item.position === 'debet' ? 1 : 2,
                avg_price_use: Number(item.avg_price_use),
                product_name: item.product_name || "",
                mr_unit_name: item.mr_unit_name || "",
                coa_inventory_code: item.coa_inventory_code || "",
                coa_inventory_name: item.coa_inventory_name || "",
                coa_coex_code: item.coa_coex_code || "",
                coa_coex_name: item.coa_coex_name || "",
                stock_in: item.position === 'debet' ? Number(Math.abs(Number(item.different_adjustment))) : 0,
                stock_out: item.position === 'credit' ? Number(Math.abs(Number(item.different_adjustment))) : 0,
                quantity_unit_sell_convention: Number(item.quantity_unit_sell_convention) || 1,
                product_barcode: item.product_barcode || "",
                unit_convention_name: item.unit_convention_name || "",
                soh: Number(item.soh),
                adjustment_detail_id: item.adjustment_detail_id
            }
        }),
        attach_file: []
    }


    const method = useForm<AdjustmentInventoryType>({
        resolver: yupResolver(AdjustmentInventoryValidation),
        defaultValues: defaultValues
    })

    const onSubmit = (data: AdjustmentInventoryType) => {
        const customValidations = validateAdjusmentDetail(data)

        const value = {
            ...finalData(data),
            adjustment_id: props.adjusmentId
        }

        if (Object.keys(customValidations).length > 0) {
            for (const path in customValidations) {
                method.setError(path as any, {
                    type: 'manual',
                    message: customValidations[path]
                })
            }
            return
        }

        return new Promise<void>((resolve) => {
            toast.promise(
                api.put("/invadjustment/update_inv_adjustment", value),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message
                }
            ).then(() => {
                method.reset(defaultValues)
                props.refetch && props.refetch()
            }).catch(() => { }).finally(resolve)
        })
    }
    

    return (
        <section className="container my-5 flex flex-col gap-5">
            <FormProvider {...method}>

                <LocationProvider>
                    
                        <LinkAccountProvider>
                            <FormDirectAdjusment title="ADJUSTMENT INVENTORY" isEdit refetch={props.refetch} />
                        </LinkAccountProvider>
                   
                </LocationProvider>

                <FooterMenu
                    delete={{ actiontype: "delete" }}
                    print={{ actiontype: "print", onClick: toggle }}
                    customElement={{ 
                        journal: <JournalAdjusment type="direct" />, 
                        attachment: <AttachmentModal /> 
                    }}
                    save={{
                        actiontype: "save",
                        type: "button",
                        color: "primary",
                        loading: method.formState.isSubmitting ? "true" : undefined,
                        onClick: method.handleSubmit(onSubmit)
                    }}
                />

                {isActive ? (<PrintAdjustmentInventory isCreate toggle={toggle} />) : null}
            </FormProvider>
        </section>
    )
}
